import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { useNotableEvents } from '../../hooks/use-notable-events';
import { EventDefinition } from '../../notable-events';
import { Undefinable } from '../../types';

interface Context {
  notableEvents: EventDefinition[];
}

const context = createContext<Undefinable<Context>>(undefined);

export const NotableEventsProvider: FC<PropsWithChildren> = ({ children }) => {
  const notableEvents = useNotableEvents();
  return (
    <context.Provider value={{ notableEvents }}>
      {children}
    </context.Provider>
  );
};

export const useNotableEventsContext = (): Context => {
  const data = useContext(context);
  if (!data) throw new Error('Missing NotableEventsProvider in tree above useNotableEventsContext');
  return data;
};
